import React from "react";
import { Link } from "react-router-dom";
import { formatDateCzk, formatPriceCzk, SUBCATEGORY_NAMES, CATEGORY_NAMES } from "@/lib/categories";
import { MapPin, Eye, Zap } from "lucide-react";
import { isTopActive } from "@/lib/moderation";

function PriceBadge({ ad }) {
  const type = ad.price_type || (ad.price_negotiable ? "negotiable" : "fixed");
  if (type === "free") {
    return <span className="stb-badge-price stb-badge-free" data-testid={`ad-price-${ad.id}`}>ZDARMA</span>;
  }
  if (type === "negotiable") {
    return <span className="stb-badge-price stb-badge-negotiable" data-testid={`ad-price-${ad.id}`}>DOHODOU</span>;
  }
  if (type === "offer") {
    return <span className="stb-badge-price stb-badge-offer" data-testid={`ad-price-${ad.id}`}>NABÍDNI CENU</span>;
  }
  return (
    <span className="stb-badge-price whitespace-nowrap" data-testid={`ad-price-${ad.id}`}>
      {formatPriceCzk(ad.price, false)}
    </span>
  );
}

export default function AdCard({ ad }) {
  const photo = (ad.photos && ad.photos[0]) || null;
  const subName = ad.subcategory ? SUBCATEGORY_NAMES[ad.subcategory] : null;
  const catName = CATEGORY_NAMES[ad.category];

  return (
    <Link
      to={`/inzerat/${ad.id}`}
      className="stb-card overflow-hidden flex flex-col md:flex-row group transition-colors no-underline"
      data-testid={`ad-card-${ad.id}`}
    >
      <div className="md:w-56 md:min-w-[14rem] bg-[#0E0E0E] relative">
        {photo ? (
          <img
            src={photo}
            alt={ad.title}
            className="w-full h-44 md:h-full object-cover transition-transform duration-300 group-hover:scale-[1.02]"
          />
        ) : (
          <div className="w-full h-44 md:h-full flex items-center justify-center text-[#4A4A4A] stb-mono">
            BEZ FOTO
          </div>
        )}
        {isTopActive(ad) && (
          <span
            className="absolute top-2 left-2 stb-badge-top stb-pulse"
            data-testid={`ad-top-badge-${ad.id}`}
          >
            <Zap size={12} /> TOP
          </span>
        )}
      </div>

      <div className="p-4 flex-1 flex flex-col">
        <div className="flex items-start justify-between gap-3">
          <h3 className="stb-h text-lg md:text-xl text-white leading-tight group-hover:text-[#FF6B00] transition-colors">
            {ad.title}
          </h3>
          <PriceBadge ad={ad} />
        </div>

        <div className="flex flex-wrap gap-2 mt-2">
          {catName && <span className="stb-chip">{catName}</span>}
          {subName && <span className="stb-chip text-[#FF6B00] border-[#FF6B00]">{subName}</span>}
        </div>

        <p className="text-sm text-[#A3A3A3] mt-3 line-clamp-3">{ad.description}</p>

        <div className="mt-auto pt-3 flex flex-wrap items-center justify-between gap-2 text-xs text-[#A3A3A3] stb-mono">
          <div className="flex items-center gap-3">
            {ad.location && (
              <span className="inline-flex items-center gap-1">
                <MapPin size={12} /> {ad.location}
              </span>
            )}
            <span className="inline-flex items-center gap-1">
              <Eye size={12} /> {ad.views}
            </span>
          </div>
          <span>{formatDateCzk(ad.created_at)}</span>
        </div>
      </div>
    </Link>
  );
}
